import React from 'react';
import { useRouteMatch } from 'react-router';
import { t } from 'i18next';
import { Button } from '@common/components/button';
import { TopNavigationBar } from '@common/components/navigation-bar';
import Permission from '@common/components/permission';
import { EPermissions } from '@common/definitions';
import { NewFormModal } from '@modules/forms/components/new-form-modal';

const FORM_CREATION_PERMISSIONS = [
  EPermissions.ORGANISATION_FORMS_CREATE,
  EPermissions.ORGANISATION_CREATOR_FORMS_CREATE
];

interface FormsTopNavigationProps {
  handleCreateForm: (templateId?: string) => void;
  canCreateForms: boolean;
  showUpgradeModal: () => void;
  isOverLimit: boolean;
  isPremium: boolean;
  setTemplatesOpen: (open: boolean) => void;
}

const FormsTopNavigation = ({
  handleCreateForm,
  canCreateForms,
  showUpgradeModal,
  isOverLimit,
  isPremium,
  setTemplatesOpen,
}: FormsTopNavigationProps) => {
  const match = useRouteMatch();

  return (
    <TopNavigationBar
      title={t('forms:filter', { context: (match.params as { filter?: string }).filter || 'all' })}
      action={(
        <Permission name={FORM_CREATION_PERMISSIONS}>
          <NewFormModal
            onOpenTemplates={() => setTemplatesOpen(true)}
            onCreateForm={() => handleCreateForm()}
          >
            <Button
              type="primary"
              size="large"
              iconRight="add"
              disabled={!isPremium && isOverLimit}
              onClick={canCreateForms ? undefined : showUpgradeModal}
            >
              {t('forms:create_form')}
            </Button>
          </NewFormModal>
        </Permission>
      )}
    />
  );
};

export default FormsTopNavigation;
